import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useFiltersStore = defineStore('filters', () => {
  const filters = ref({});
  const showCard = ref(true)

  const setFilters = (filtersVal) => {
    filters.value = filtersVal
  }

  const setShowCard = (showCardVal) => {
    showCard.value = showCardVal
    localStorage.setItem('showCard', JSON.stringify(showCardVal))
  }

  const getShowCard = () => {
    const showCard = localStorage.getItem('showCard')
    return showCard ? JSON.parse(showCard) : true
  }

  return {
    filters,
    showCard,
    setFilters,
    setShowCard,
    getShowCard
  }
})

export const usePageNumberStore = defineStore('pageNumber', () => {
  const page = ref({})

  const getPage = (componente) => {
    if (page.value[componente]) {
      return page.value[componente]
    }
    return 1
  }

  const setPageNumber = (pageNumber, componente) => {
    page.value[componente] = pageNumber
  }

  return {
    page,
    getPage,
    setPageNumber
  }
})

export const useSummaryCampaign = defineStore('campaignSummary', () => {
  const summaryCampaign = ref({})

  const setSummary = (campaignId, summary) => {
    summaryCampaign.value[campaignId] = summary
  }

  return {
    summaryCampaign,
    setSummary
  }
})

